// test232
(232 && 0);
